import { createContext, useState, useEffect } from 'react';
import { getPendingSales, markSaleSynced } from '../services/offline-db';
import api from '../services/api';

export const OfflineContext = createContext();

export function OfflineProvider({ children }) {
  const [online, setOnline] = useState(navigator.onLine);
  const [syncing, setSyncing] = useState(false);
  const [pendingCount, setPendingCount] = useState(0);

  const checkPending = async () => {
    const pending = await getPendingSales();
    setPendingCount(pending.length);
  };

  useEffect(() => {
    checkPending();
    const interval = setInterval(checkPending, 2000);
    return () => clearInterval(interval);
  }, []);

  const syncPendingSales = async () => {
    if (!navigator.onLine) return;
    
    const pending = await getPendingSales();
    if (pending.length === 0) return;

    setSyncing(true);
    try {
      const res = await api.post('/sales/sync', { sales: pending });
      console.log('Sync Results:', res.data);
      
      // Remove successfully synced or skipped (duplicates)
      for (const sale of pending) {
        // If it was synced successfully or skipped as duplicate
        await markSaleSynced(sale.id);
      }
    } catch (err) {
      console.error('Sync Error:', err);
    } finally {
      setSyncing(false);
    }
  };

  useEffect(() => {
    const handleOnline = () => {
      setOnline(true);
      syncPendingSales();
    };
    const handleOffline = () => setOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Initial sync check
    if (navigator.onLine) syncPendingSales();

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return (
    <OfflineContext.Provider value={{ online, syncing, syncPendingSales, pendingCount }}>
      {children}
    </OfflineContext.Provider>
  );
}